<template>
  <div class="ai-stt-format ai-items mb0">
    <div class="ai-stt-format-item ai-item-wrap" v-for="(item, idx) in list" :key="idx">
      <div class="ai-item">
        <el-input v-model="item.match" placeholder="正则匹配；当发送给前端的内容符合这个正则时执行这个规则" title="正则匹配；当发送给前端的内容符合这个正则时执行这个规则"/>
        <el-input v-model="item.pattern" placeholder="正则匹配STT生成的文本" title="正则匹配STT生成的文本"/>
        <el-input v-model="item.replace" placeholder="要替换的目标文本" title="要替换的目标文本"/>
        <el-button type="danger" tabindex="-1" icon="el-icon-delete" @click="removeItem(idx)"></el-button>
        <el-button icon="el-icon-plus" tabindex="-1" @click="addItem(idx)"></el-button>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "stt_format_form",
  props: {
    value: Array,
  },
  computed: {
    list() {
      let val = this.value;
      if (Array.isArray(val) && val.length > 0) {
        return val;
      }
      console.log('stt-format init', val);
      val = [{}];
      this.$emit('input', val);
      return val;
    }
  },
  methods: {
    addItem(index) {
      this.list.splice(index + 1, 0, {})
    },
    removeItem(index) {
      if (this.list.length > 1) {
        this.list.splice(index, 1)
      } else {
        this.list.splice(index, 1, {})
      }
    },
  }
}
</script>

<style scoped>

</style>